import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/admin/components/Footer/Footer.js